import React from "react";
import RiskName from "../riskName/riskName";
import { RisksId } from "../../../../helpers/risk";
import DropDown from "../../../sharedComponents/dropDown/dropDown";
import { CatAndDogCountDropDown, CatAndDogInsuranceSumDropDown } from "../../../../helpers/catAndDog";
import { inject, observer } from "mobx-react";
import { CalculateStore } from "../../../../stores/calculateStore";
import Notification from "../../../sharedComponents/notification/notification";
import InsuranceSumDropDown from "../insuranceSumDropDown/InsuranceSumDropDown";
import { ProposalStore } from "../../../../stores/proposalStore";
import { displayAdditionalRiskForm } from "../../../../helpers/risksNetwork";

interface CatAndDogProps {
  calculateStore?: CalculateStore;
  proposalStore?: ProposalStore;
}

@inject("calculateStore", "uiFlagsStore", "proposalStore")
@observer
export default class CatAndDog extends React.Component<CatAndDogProps> {

  public render() {
    const calculateStore = this.props.calculateStore!;
    const proposalStore = this.props.proposalStore!;
    const catAndDog = calculateStore.additionalInsurances.catAndDog;
    const displayForm = displayAdditionalRiskForm(calculateStore.additionalInsurances.catAndDog);

    return (
      <div className="section cat-and-dog">
        <RiskName
          checkboxOnChange={(event) => {
            calculateStore.setAdditionalInsuranceFieldChecked(RisksId.catAndDog, event.target.checked);
          }}
          riskId={RisksId.catAndDog}
          displayIcon={true}
        />
        {displayForm && (
          <div className="cat-and-dog-wrapper">
            <div className="risk-value">
              <DropDown
                onChange={(value) => {
                  calculateStore.setDogsCount(value);
                  const animalsCount = calculateStore.additionalInsurances.catAndDog.catAndDogCount();
                  proposalStore.catAndDog.setNumberOfAnimals(animalsCount);
                  this.validate();
                }}
                value={catAndDog.dogsCount}
                items={CatAndDogCountDropDown}
                topLabel="Liczba psów"
              />
              <DropDown
                onChange={(value) => {
                  calculateStore.setCatsCount(value);
                  const animalsCount = calculateStore.additionalInsurances.catAndDog.catAndDogCount();
                  proposalStore.catAndDog.setNumberOfAnimals(animalsCount);
                  this.validate();
                }}
                value={catAndDog.catsCount}
                items={CatAndDogCountDropDown}
                topLabel="Liczba kotów"
              />
              <InsuranceSumDropDown
                riskId={RisksId.catAndDog}
                value={catAndDog.insuranceSum}
                items={CatAndDogInsuranceSumDropDown} />
            </div>
            {!!calculateStore.additionalInsurances.catAndDog.errorMessage && <Notification type="error" message={calculateStore.additionalInsurances.catAndDog.errorMessage} />}
          </div>
        )}
      </div>
    );
  }

  private validate() {
    this.props.calculateStore!.additionalInsurances.catAndDog.validateCatAndDogCount();
  }
}
